import React from "react";
import { ShieldCheck } from "lucide-react";

export const PAYOUT_PROTECTION_COPY =
  "Pay through LocaNest to stay protected. We hold your payment and transfer it to the owner within 3–4 days — commission-free. If you pay a broker/owner directly outside LocaNest, we cannot guarantee your money or help resolve any dispute.";

export default function PayoutProtectionNotice({ className = "", compact = false }) {
  return (
    <div className={`rounded-md bg-[#2B3A67] text-[#FDFBF7] p-3.5 flex gap-2.5 ${className}`} data-testid="payout-protection-notice">
      <ShieldCheck size={compact ? 15 : 18} className="shrink-0 mt-0.5 text-[#D4DEC6]" />
      <div className={compact ? "text-[11px] leading-relaxed" : "text-xs leading-relaxed"}>
        <div className="uppercase tracking-[0.2em] text-[10px] font-semibold text-[#D4DEC6] mb-0.5">Payment protection</div>
        {PAYOUT_PROTECTION_COPY}
      </div>
    </div>
  );
}
